module.exports = __webpack_public_path__ + "static/media/DSCF3778.6e3437fa.jpg";